var localePrefixMap = {
  'fr-ca': '/fr',
  'es-us': '/es',
  'fr-ch': '/fr',
  'fr-be': '/fr',
  'it-ch': '/it',
  'en-jp': '/en'
};
var getUrlPrefix = function getUrlPrefix(locale) {
  return localePrefixMap[locale.toLocaleLowerCase()] || '';
};

export { getUrlPrefix };
//# sourceMappingURL=secondaryLanguageUrlPrefix.js.map
